const ListCreate = () => import('@/modules/lists/views/ListCreate.vue')
const ListEdit = () => import('@/modules/lists/views/ListEdit.vue')
const ListIndex = () => import('@/modules/lists/views/ListIndex.vue')
const ListShow = () => import('@/modules/lists/views/ListShow.vue')
const ListCustomShow = () => import('@/modules/lists/views/ListCustomShow.vue')

export default [
  {
    name: 'lists.create',
    path: '/lists/create',
    component: ListCreate,
    meta: { requiresAuthentication: true }
  },
  {
    name: 'lists.edit',
    path: '/:username/lists/:slug/edit',
    component: ListEdit,
    meta: { requiresAuthentication: true }
  },
  {
    name: 'lists.show',
    path: '/:username/lists/:slug',
    component: ListShow
  },
  {
    name: 'lists.index',
    path: '/lists',
    component: ListIndex,
    meta: { requiresAuthentication: true }
  },
  {
    name: 'lists.custom.show',
    path: '/lists/:slug',
    component: ListCustomShow
  }
]
